import { render, staticRenderFns } from "./form-dzxy.vue?vue&type=template&id=1e995215&scoped=true&"
import script from "./form-dzxy.vue?vue&type=script&lang=js&"
export * from "./form-dzxy.vue?vue&type=script&lang=js&"
import style0 from "./form-dzxy.vue?vue&type=style&index=0&id=1e995215&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e995215",
  null
  
)

export default component.exports